export default {
  path: '/2019AssociationEcologyMeeting',
  name: 'AssociationEcologyMeeting2019',
  component: () => import('./home.vue'),
  base: '/2019AssociationEcologyMeeting/',
  meta: {
    title: '万物归群，智慧生长——2019年度社群生态大会',
  },
  children: [
    {
      path: 'List',
      component: () => import('./List.vue'),
      name: '2019AssociationEcologyMeetingList',
      meta: {
        title: '万物归群，智慧生长——2019年度社群生态大会',
      },
    },
    {
      path: 'Register',
      component: () => import('./Register.vue'),
      name: '2019AssociationEcologyMeetingRegister',
      meta: {
        title: '万物归群，智慧生长——2019年度社群生态大会',
      },
    },
    {
      path: 'DetailPage',
      component: () => import('./DetailPage.vue'),
      name: '2019AssociationEcologyMeetingDetailPage',
      meta: {
        title: '万物归群，智慧生长——2019年度社群生态大会',
      },
    },
    {
      path: 'Rules',
      component: () => import('./Rules.vue'),
      name: '2019AssociationEcologyMeetingRules',
      meta: {
        title: '万物归群，智慧生长——2019年度社群生态大会',
      },
    },
    {
      path: 'NewsPage',
      component: () => import('./NewsPage.vue'),
      name: '2019AssociationEcologyMeetingNewsPage',
      meta: {
        title: '万物归群，智慧生长——2019年度社群生态大会',
      },
    },
    {
      path: 'Searchpage',
      component: () => import('./Searchpage.vue'),
      name: '2019AssociationEcologyMeetingSearchpage',
      meta: {
        title: '万物归群，智慧生长——2019年度社群生态大会',
      },
    },
  ],
};
